import { render, staticRenderFns } from "./250320.vue?vue&type=template&id=098863e4&scoped=true&"
import script from "./250320.vue?vue&type=script&lang=js&"
export * from "./250320.vue?vue&type=script&lang=js&"
import style0 from "./250320.vue?vue&type=style&index=0&id=098863e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098863e4",
  null
  
)

export default component.exports